import { render } from "./FilterSingle.vue?vue&type=template&id=5c444d56&bindings={\"selectedOption\":\"options\",\"suffix\":\"options\",\"display\":\"options\",\"apply\":\"options\"}"
import script from "./FilterSingle.vue?vue&type=script&lang=js"
export * from "./FilterSingle.vue?vue&type=script&lang=js"
script.render = render

export default script